import React from "react";

export type TDayScoresProps = React.SVGAttributes<SVGElement>;

export function DayScores({ ...rest }: TDayScoresProps) {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" {...rest}>
      <style>
        {`@keyframes bar-1_h {
            0 % { height: 7px; animation- timing - function: cubic- bezier(0.42, 0, 0.58, 1); } 
            50% {height: 3px; animation-timing-function: cubic-bezier(0.42,0,0.58,1); } 
            100% {height: 7px;}}
          @keyframes bar-2_h {
            0 % { height: 10px; animation- timing - function: cubic- bezier(0.42, 0, 0.58, 1); } 
            50% {height: 7px; animation-timing-function: cubic-bezier(0.42,0,0.58,1); } 
            100% {height: 10px;}}
          @keyframes bar-3_h {
            0 % { height: 4px; animation- timing - function: cubic- bezier(0.42, 0, 0.58, 1); } 
            50% {height: 10px; animation-timing-function: cubic-bezier(0.42,0,0.58,1); } 
            100% {height: 3px;}}`}
      </style>
      <g transform="translate(13,13) translate(-13,-13)">
        <path d="M6,22C5.45,22,4.97917,21.8042,4.5875,21.4125C4.19583,21.0208,4,20.55,4,20L4,6C4,5.45,4.19583,4.97917,4.5875,4.5875C4.97917,4.19583,
          5.45,4,6,4L20,4C20.55,4,21.0208,4.19583,21.4125,4.5875C21.8042,4.97917,22,5.45,22,6L22,20C22,20.55,21.8042,21.0208,21.4125,21.4125C21.0208,
          21.8042,20.55,22,20,22L6,22ZM6,20L20,20L20,6L6,6L6,20Z" fill="#7f94a1" transform="translate(13,13) translate(-13,-13)" />
        <rect
          id="bar-1"
          width="2"
          height="7"
          fill="#7f94a1"
          rx="0"
          stroke="none"
          transform="translate(9,15.5) rotate(180) translate(-1,-2.5)"
          style={{ animation: "4s linear infinite both bar-1_h" }}
        />
        <rect
          id="bar-2"
          width="2"
          height="10"
          fill="#7f94a1"
          rx="0"
          stroke="none"
          transform="translate(13,12.5) rotate(180) translate(-1,-5.5)"
          style={{ animation: "4s linear infinite both bar-2_h" }}
        />
        <rect
          id="bar-3"
          width="2"
          height="4"
          fill="#7f94a1"
          rx="0"
          stroke="none"
          transform="translate(17,18.5) rotate(180) translate(-1,0.5)"
          style={{ animation: "4s linear infinite both bar-3_h" }}
        />
      </g>
    </svg>
  );
}
